<template>
  <div>
    <el-tooltip :content="$t('system_account.invitation.invitationBtnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button icon round type="warning" @click.native="handleInvitation()" class="text-nowrap zi_100">
        <i class="mdi mdi_icon mdi-24px mdi-send-outline"/>
      </base-button>
    </el-tooltip>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";

export default {
  name: "SystemAccountInvitation",
  props: {
    systemAccount: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ...mapState({
      error: state => state.system_account.error
    }),
  },
  methods:
    {
      ...mapActions(['InviteSystemAccount']),
      handleInvitation() {

        let systemAccount = this.systemAccount
        let id = null;
        if (!systemAccount) {
          // Current logged user
          systemAccount = this.$auth.user()
        } else {
          // Id of account for which password should be reset.
          id = systemAccount.id
        }

        swal({
          title: this.$t('system_account.invitation.text'),
          text: systemAccount.username,
          buttonsStyling: false,
          confirmButtonText: this.$t('system_account.invitation.actionBtnLabel'),
          cancelButtonText: this.$t('system_account.invitation.cancelBtnLabel'),
          confirmButtonClass: 'btn btn-warning',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.InviteSystemAccount(this.systemAccount.id).then(() => {
                if (this.error == null) {
                  this.$notify({
                    type: 'success',
                    message: this.$t('system_account.invitation.invitationNotification', {username: this.systemAccount.username}),
                    icon: 'tim-icons icon-alert-circle-exc'
                  })
                }
              }
            )
          }
        });
      },
      showNewPassword() {
        swal({
          title: this.$t('system_account.invitation.viewTitle'),
          text: this.newPsw,
          buttonsStyling: false,
          confirmButtonText: this.$t('system_account.invitation.viewBtnLabel'),
          confirmButtonClass: 'btn btn-primary',
          type: 'info',
        })
      }
    },
}
</script>

<style scoped>

</style>
